(function ($) {
    var $header = $(".header");

    function stickyMenu() {
        var windowTop = $(window).scrollTop()

        if (windowTop > 5) {
            $header.addClass('header--sticky');
        } else {
            $header.removeClass('header--sticky');
        }
    }

    $('#show-search').click(function (e) {
        e.preventDefault();

        $(this).addClass('hidden');
        $('.header__search .form-group').addClass('active');
        $('.header__search .form-control').focus();
    });

    $(document).click(function (e) {
        var container = $(".header__search");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $('.header__search .form-group').removeClass('active');
            setTimeout(function () {
                $('#show-search').removeClass('hidden');
            }, 550);
        }
    });

    stickyMenu();
    $(window).on('scroll', stickyMenu);
}(jQuery));